import type { ComponentPropsWithoutRef, FunctionComponent } from 'react'
import React from 'react'

import { TypographyV2 } from '../../../Seatbelt2/Foundations/Typography'
import type { AnswerRadioProps } from '../AnswerRadio'
import AnswerRadio from '../AnswerRadio'
import styles from './QuestionRow.module.scss'

export const QuestionRow: FunctionComponent<QuestionRowProps> = ({
  questionText,
  answers,
  ...rest
}) => {
  return (
    <fieldset
      data-testid="question-row"
      className={styles.questionRow}
      {...rest}
    >
      <legend>
        <TypographyV2
          className={'sb-padding-bottom-3'}
          textStyle="sb-text-interface-body-small-strong"
        >
          {questionText}
        </TypographyV2>
      </legend>
      <div className={styles.questionRowAnswerRadioWrapper}>
        {answers.map(
          (
            {
              description,
              label,
              icon,
              onClickCallback,
              selected,
              value,
              priceBand,
            },
            index
          ) => (
            <AnswerRadio
              key={label}
              label={label}
              description={description}
              answerIndex={index}
              icon={icon}
              value={value}
              selected={selected}
              priceBand={priceBand}
              onClickCallback={onClickCallback}
              className={styles.questionRowAnswerRadio}
              questionText={questionText}
              totalAnswers={answers.length}
            />
          )
        )}
      </div>
    </fieldset>
  )
}

///////// IMPLEMENTATION /////////

export type QuestionRowProps = {
  /**
   * Question text the row of AnswerRadio buttons will relate to
   */
  questionText: string
  /**
   * Array of answer objects containing AnswerRadio base props
   */
  answers: Array<AnswerRadioProps>
} & ComponentPropsWithoutRef<'fieldset'>
